import type { TokenName } from '~/lib/theme-colors';

export const LISTING_VIDEO_HEADER = 'Rendering stats for listing videos in SocialBAY.';

export const LIST_OF_CARDS: Record<string, string> = {
  lastProcessedTimestamp: 'Last processed time',
  totalCount: 'Total video jobs attempted',
  numberOfQueuedJobs: 'Queued jobs',
  countRendered: 'Videos successfully rendered',
  countSkipped: 'Videos skipped',
  countFailed: 'Videos failed',
  avgWaitTime: 'Average wait time',
  avgRenderServiceTime: 'Average complete processing time',
  avgRenderTime: 'Average video render time',
  avgValidationTime: 'Average photo validation time',
  avgPhotoDownloadTime: 'Average photo and music download time',
  avgThumbnailGenerationTime: 'Average thumbnail generation time',
  avgUploadTime: 'Average upload time',
  avgImageCount: 'Average count of photos per video',
  avgImageWidth: 'Average photo dimensions (all videos)', // avgImageWidth X avgImageHeight
  // lowQualityVideoDimensions: 'AVERAGE PHOTO DIMENSIONS (LOW QUALITY ERROR)',
  unbranded_listing_video: 'Unbranded videos render',
};

/** Stats the service sends as raw milliseconds; the tiles show them through formatDuration(). */
export const DURATION_KEYS = new Set([
  'avgWaitTime',
  'avgRenderServiceTime',
  'avgRenderTime',
  'avgValidationTime',
  'avgPhotoDownloadTime',
  'avgThumbnailGenerationTime',
  'avgUploadTime',
]);

// Donut slices are error codes, so the state tokens lead.
export const PIE_TOKENS: TokenName[] = [
  'error-500',
  'warning-500',
  'orange-500',
  'theme-pink-500',
  'theme-purple-500',
  'brand-500',
  'gray-500',
];
